// extracted by mini-css-extract-plugin
export default {"flecks":"Flecks_flecks__MgpFx","fleck":"Flecks_fleck__59VjK","MorphAndRotate":"Flecks_MorphAndRotate__nzbo2"};